import React from 'react';
import {getTemplateUri} from "../../serverInfo";

export default class DesignCenterHeader extends  React.Component {

    endoplusLogoDesignCenter = `${getTemplateUri()}/dist/img/endoplus-logo.png`;
    cartBlue = `${getTemplateUri()}/dist/img/shopping-cart-blue.svg`;
    searchIcon = `${getTemplateUri()}/dist/img/search-icon.svg`;

    constructor(...arg){
        super(...arg);
    }

    componentDidMount() {

    }

    /* TODO: SIDEBAR for Cart Flyout
            <button className={'btn design-center-navbar__btn'} data-toggle={'collapse'}
                        data-target={'#designCenterSidebar'}
                        aria-controls={'designCenterSidebar'}
                        aria-expanded={'false'} aria-label={'Toggle navigation'}>
                        {DesignCenterHeader.renderHamburgerButton()}
                    </button>
            <div className={'collapse design-center-sidebar'} id={'designCenterSidebar'}>
            </div>
     */

    renderSearchBox(preClass, preID, wrapperClass) {
        return <div className={`input-group ${preClass}__search-wrapper ${wrapperClass}`}>
            <input type={'text'} className={`form-control ${preClass}__search-box`}
            placeholder={'SEARCH BY PART NO.'} aria-describedby={`${preID}SearchBtn`} />
            <div className={'input-group-append'}>
                <button type={'submit'} className={`btn ${preClass}__search-btn`} id={`${preID}SearchBtn`}>
                    <img src={this.searchIcon} alt={''}/>
                </button>
            </div>
        </div>;
    }

    render() {
        const listLinksTexts = this.props.linkstexts.map((text, index) =>
            <a className="mx-1" href={text.link} key={index}>{text.text}</a>
        );

        return <nav className={'navbar design-center-navbar'}>
            <a className={'navbar-brand design-center-navbar__brand'} href={'/'}>
                <img src={this.endoplusLogoDesignCenter} alt={''}/>
            </a>
            <div className={'design-center-navbar__btn-wrapper'}>
                <div id={'designCenterNav'} className={'collapse width font-weight-bold'}>
                    <div className={'design-center-nav__wrapper'}>
                        {listLinksTexts}
                        {this.renderSearchBox('design-center-nav', 'designCenterNav', 'd-flex d-sm-none')}
                    </div>
                </div>
                {this.renderSearchBox('design-center-navbar', 'designCenterNavbar', 'd-sm-flex')}
                <a className={'btn design-center-navbar__btn'} href={'/cart/'}>
                    <img src={this.cartBlue} alt={''}/>
                </a>
                <button className={'btn design-center-navbar__btn collapsed'} data-toggle={'collapse'} aria-expanded={'false'}
                    data-target={'#designCenterNav'} aria-controls={'designCenterNav'} type={'button'}>
                    {DesignCenterHeader.renderHamburgerButton()}
                </button>
            </div>
        </nav>;
    }

    static renderHamburgerButton() {
        return <div className={'hamburger-endoplus hamburger-design-center'}>
            <span></span>
            <span></span>
            <span></span>
        </div>;
    }

    static renderFlyoutCart() {
        return <button className={'btn design-center-navbar__btn'} data-toggle={'collapse'}
            data-target={'#navbarToggleExternalContent'}
            aria-controls={'navbarToggleExternalContent'}
            aria-expanded={'false'} aria-label={'Toggle navigation'}>
                <img src={this.cartBlue} alt={''}/>
        </button>;
    }
}
